import { useModuleBEM } from "@b2bportal/core-themes";
import { Pill, type PillComponentProps } from "@tenant/ui";
import clsx from "clsx";
import styles from "./ReservationStatusPill.module.scss";

export const ReservationStatusPill = ({
  className,
  ...rest
}: PillComponentProps) => {
  const [block] = useModuleBEM(styles, "ReservationStatusPill");

  return <Pill className={clsx(block, className)} {...rest} />;
};
